<template>
  <div :class="wrapperClass" style="background-color: #E7F6F6; min-height: 100vh; display: flex; flex-direction: column;">
    <profile-header></profile-header>
    <TitleContainer :title="title" :isExtraWidth="extraWidth" v-if="showTitleContainer"/>
    <div class="container contact-container" style="flex: 1; display: flex; flex-direction: column;">
        <!-- <div class="container content-head" :class="dynamicClass" style="background: #EDEDED; height: 50px; border-bottom: 1px solid #B3B3B3">
            <h2 style="padding: 10px 0px; font-size: 20px;">登録情報の編集</h2>
        </div> -->
        <div class="user-content" :class="{ 'user-content-details': fromDetails }" style="flex: 1;">
          <div class="content-wrapper" style="margin-bottom: 20px !important;">
            <div class="my-auto w-100 main-area">
              <div class="profile-detail">
                <div class="profile-detail-block">
                  <!-- Content of the profile-detail block -->
                  <slot></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
        <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import ProfileHeader from "@/components/header.vue";
import TitleContainer from "./TitleContainer.vue";
export default {
  name: 'UserWrapper',
  components: { ProfileHeader, TitleContainer },
  props: {
    extraWidth: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    showTitleContainer: {
      type: Boolean,
      default: true
    },
    fromDetails: {
      type: Boolean,
      default: false
    }
  },
  // data() {
  //   return {
  //     dynamicClass: this.getClassForScreenSize()
  //   };
  // },
  computed: {
    wrapperClass() {
      return 'user-wrapper w-100';
    }
  },
  // mounted() {
  //   window.addEventListener('resize', this.updateClassForScreenSize);
  // },
  // beforeDestroy() {
  //   window.removeEventListener('resize', this.updateClassForScreenSize);
  // },
  // methods: {
  //   updateClassForScreenSize() {
  //     // Update the dynamic class based on screen size
  //     this.dynamicClass = this.getClassForScreenSize();
  //   },
  //   getClassForScreenSize() {
  //     if (this.extraWidth && window.innerWidth >= 1024) {
  //       return 'mx-5';
  //     } else {
  //       return '';
  //     }
  //   }
  // }
};
</script>
<style scoped>
@media (max-width: 1024px){
  .container.contact-container {
    padding: 8px !important;
  }
}

.contact-container {
  background-color: #E7F6F6;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.content-wrapper {
  padding-left: 15px;
  padding-right: 15px;
}

@media (min-width: 576px) {
  .content-wrapper {
    padding-left: 15px;
    padding-right: 15px;
  }
}

.user-content-details {
  border-radius: 10px;
    -webkit-box-shadow: 0px 0px 20px -2px rgba(1, 58, 61, 0.10);
    box-shadow: 0px 0px 20px -2px rgba(1, 58, 61, 0.10);
    background-color: #fff;
    overflow: hidden;
    padding: 0px !important;
}
</style>
